import script from "./mobileTips.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileTips.vue?vue&type=script&setup=true&lang=js"

import "./mobileTips.vue?vue&type=style&index=0&id=d357ce0a&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d357ce0a"]])

export default __exports__